// extracted by mini-css-extract-plugin
export default {"card":"wZ-z","carouselContainer":"xZ-z","carouselContent":"yZ-z"};